import { inject } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AuthService } from '@core/services';

/**
 * A guard that checks if the user is authenticated before allowing access to a route.
 * If the user is not authenticated, it redirects to the login page with the redirect URL.
 * @returns {boolean | UrlTree} - Returns `true` if the user is authenticated, or a `UrlTree` object that redirects to the login page with the redirect URL.
 */
export const authGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.authenticated) {
    return true;
  }

  // Set our navigation extras object
  // that contains our global query params and fragment
  const navigationExtras: NavigationExtras = {
    queryParams: {
      redirectUrl: authService.redirectUrl,
    },
  };

  // Redirect to the login page with extras
  return router.createUrlTree(['/login'], navigationExtras);
};
